module.exports = __webpack_public_path__ + "static/media/display-2@768.afa1959a.png";